import { delay } from "@/utils";
export const panel = {
  state: {
    mode: "planning",
    port: undefined,
    weather: undefined,
    chart: undefined,
    detection: false,
  },
  reducers: {
    updatePort: (state, payload) => {
      return { ...state, port: payload };
    },
    updateWeather: (state, payload) => {
      return { ...state, weather: payload };
    },
    updateChart: (state, payload) => {
      return { ...state, chart: payload };
    },
    updateDetection: (state, payload) => {
      return { ...state, detection: payload };
    },
    updateMode: (state, payload) => {
      return { ...state, mode: payload }
    },
    closePanel: (state, payload) => {
      return { ...state, [payload]: undefined }
    },
    reset: (state, payload) => {
      return {
        ...state,
        port: undefined,
        weather: undefined,
        chart: undefined,
        detection: undefined
      }
    }
  },
  effects: (dispatch) => ({
    async loadPort({ name, enName }) {
      await delay(100);
      dispatch.panel.updatePort({
        name: name,
        enName: enName,
        description:
          "摩尔曼斯克（MURMANSK）位于北冰洋的巴伦支海科拉湾东岸，为一不冻港，可全年通航是俄罗斯北海航线的起点和渔港。进出口货物以鱼、煤及矿石等为主。",
      });
    },
  }),
  selectors: (slice, createSelector, hasProps) => ({
    selectPort() {
      return slice((panel) => panel.port);
    },
    selectWeather() {
      return slice((panel) => panel.weather);
    },
    selectChart() {
      return slice((panel) => panel.chart);
    },
  }),
};
